interface TableLegendProps {
  className?: string
}

export function TableLegend({ className = '' }: TableLegendProps) {
  return (
    <div className={`flex flex-wrap gap-4 text-sm justify-center bg-white/90 backdrop-blur-sm border border-gray-200 rounded-2xl p-4 shadow-lg ${className}`}>
      <div className="flex items-center gap-2">
        <div className="w-4 h-4 bg-white border border-gray-300 rounded"></div>
        <span className="text-gray-600 font-hebrew font-medium">פנוי להרשמה</span>
      </div>

      <div className="flex items-center gap-2">
        <div className="w-4 h-4 bg-blue-100 border border-blue-300 rounded flex items-center justify-center">
          <svg className="w-3 h-3 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
          </svg>
        </div>
        <span className="text-gray-600 font-hebrew font-medium">בתהליך רישום</span>
      </div>

      <div className="flex items-center gap-2">
        <div className="w-4 h-4 bg-orange-100 border border-orange-300 rounded flex items-center justify-center">
          <svg className="w-3 h-3 text-orange-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>
        <span className="text-gray-600 font-hebrew font-medium">רישום של משתמש אחר</span>
      </div>

      <div className="flex items-center gap-2">
        <div className="w-4 h-4 bg-green-100 border border-green-300 rounded flex items-center justify-center">
          <svg className="w-3 h-3 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
          </svg>
        </div>
        <span className="text-gray-600 font-hebrew font-medium">תפוס</span>
      </div>

      <div className="flex items-center gap-2">
        <div className="w-4 h-4 bg-purple-100 border border-purple-300 rounded"></div>
        <span className="text-gray-600 font-hebrew font-medium">שבת - אין תורנות</span>
      </div>

      <div className="flex items-center gap-2">
        <div className="w-4 h-4 bg-green-100 border border-green-300 rounded"></div>
        <span className="text-gray-600 font-hebrew font-medium">יום קייטנה</span>
      </div>
    </div>
  )
}
